export function OrderTypeFilterButton(props) {
    return (<>
            <div style={`${props.GetIsOrderTypeSelectedFunc(props.OrderType) ? `background-color: ${props.PrimaryColor}` : ""}`} class={`ordertype-filter-button ${props.GetIsOrderTypeSelectedFunc(props.OrderType) ? "selected" : ""}`} onClick={() => props.OnClick(props.OrderType)}>
                {props.OrderType.Code}
            </div>
        </>);
}
